module.exports = "<div #subscriberDiv id=\"subscriber\"></div>"